module.exports = __webpack_public_path__ + "createstatic/media/logout.1c35214d.svg";